import style from './Logo.module.scss'
import logo from "./logo.png";

const Header = (props) => {
  return (
    <div className={style.logo_container}>
      <a href="/" className={style.logo_container__link}>
        <img src={logo} alt="Logo" className={style.logo_container__image} />
      </a>
    </div>
  );
}

export default Header;